import React, { useEffect, useState } from 'react'
import FetchApi from '../customhooks/functionFetchApi'
import Spinner from 'react-bootstrap/Spinner';
// import { jouranllist } from './object-default/journalobject';
import Journaltablebygroup from './components/journaltablebygroup';
import { FaFileSignature } from "react-icons/fa";

const Journallistbygroup = () => {

  const FetchApis = new FetchApi();
  const [loading, setLoading] = useState(false);
  const [datajournal, setDatajournal] = useState([]);

  const codes = sessionStorage.getItem('EmCode')

  useEffect(() => {
    loadingdata();
  }, [])

  const loadingdata = () => {
    setLoading(true)

    setTimeout(() => {
      FetchApis.FethcGet(`/journal/getjournalSendRunflowByEmcode/${codes}`).then((resultdata) => {
        if (resultdata) {
          setDatajournal(resultdata.data)
        }
        setLoading(false);
      })
    }, 1000);

  }

  return (
    <div>
      <div style={{ backgroundColor: '#E5E7E7' }}>

        <label style={{ fontSize: 20, margin: 5, padding: 5 }}><FaFileSignature /> รายการ รอตรวจสอบ </label>
      </div>
      {loading ? <div className='body-center-page'><Spinner
        as="span"
        animation="grow"
        variant="success"
        size={200}
        role="status"
        aria-hidden="true" /> LOADIN ....</div> : <div><Journaltablebygroup datatable={datajournal.data} /></div>}
    </div>
  )
}

export default Journallistbygroup